import Hotjar from '@hotjar/browser';
import { EnvironmentVariables, getEnvironmentVariable } from '@Services/index';

export const initHotJar = () => {
  Hotjar.init(getEnvironmentVariable(EnvironmentVariables.VITE_APP_HOTJAR), 6, {
    debug: import.meta.env.mode === 'development',
  });
};

export const setHotJarPeopleData = (customerId: string, data = {}) => {
  Hotjar.identify(customerId, data);
};
